import { __assign, __extends, __rest } from "tslib";
import React, { PureComponent } from 'react';
import iconFactory from './';
var Icon = (function (_super) {
    __extends(Icon, _super);
    function Icon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Icon.prototype.render = function () {
        var _a = this.props, fill = _a.fill, rest = __rest(_a, ["fill"]);
        return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, rest),
            React.createElement("path", { fill: fill, fillRule: "evenodd", d: "M13.414 12l3.536-3.536-1.414-1.414L12 10.586 8.464 7.05 7.05 8.464 10.586 12 7.05 15.536l1.414 1.414L12 13.414l3.536 3.536 1.414-1.414L13.414 12zm-7.07 5.657A8 8 0 1 1 17.656 6.343 8 8 0 0 1 6.343 17.657z" })));
    };
    return Icon;
}(PureComponent));
export default iconFactory(Icon, 'Clear');
//# sourceMappingURL=Clear.js.map